export default __webpack_public_path__ + "static/background-cta-2d20904390abccc5771a217a9f5029f2.jpg";